import { render } from "./RegulationNews.vue?vue&type=template&id=d8066080"
import script from "./RegulationNews.vue?vue&type=script&lang=js"
export * from "./RegulationNews.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\PhuongVangDanh\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__